import { Platform, StyleProp, StyleSheet, View, ViewStyle } from "react-native";
import { Dispatch, RefObject, SetStateAction, useCallback, useEffect, useRef } from "react";
import DropDownPicker from "react-native-dropdown-picker";
import CustomText from "../../general/CustomText/CustomText";

interface SortingDropdownProps {
  sortBy: string;
  setSortBy: Dispatch<SetStateAction<string>>;
  sortDropdownOpen: boolean;
  setSortDropdownOpen: Dispatch<SetStateAction<boolean>>;
  sortItems: { label: string; value: string }[];
  label?: string;
  customStyle?: StyleProp<ViewStyle>;
}
const SortingDropdown = ({
  sortBy,
  setSortBy,
  sortDropdownOpen,
  setSortDropdownOpen,
  sortItems,
  label,
  customStyle,
}: SortingDropdownProps) => {
  const ref = useRef(null);

  useEffect(() => {
    if (Platform.OS === "web" && sortDropdownOpen) {
      const handleClickOutside = (event) => {
        const catchClick = ref.current?.contains?.(event.target);
        if (!catchClick) {
          setSortDropdownOpen(false);
        }
      };
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }
  }, [sortDropdownOpen, setSortDropdownOpen, ref]);

  return (
    <View style={styles.sortByContainer} ref={ref as unknown as RefObject<View>} id={`${label || "dropdown"}-dropdown`}>
      {label && (
        <CustomText
          size="s"
          weight="normal"
          style={[{ display: "flex", color: "#667085", minWidth: 50 }, customStyle]}
          text={label}
        />
      )}
      <DropDownPicker
        open={sortDropdownOpen}
        value={sortBy}
        items={sortItems}
        setOpen={(value) => setSortDropdownOpen(value)}
        setValue={setSortBy}
        dropDownContainerStyle={styles.dropdownContainer}
        style={styles.dropdownField}
        textStyle={styles.dropdownText}
        zIndex={3000}
        onSelectItem={() => setSortDropdownOpen(false)}
        onClose={() => setSortDropdownOpen(false)}
        onChangeValue={(value) => {
          setSortBy(value);
          setSortDropdownOpen(false);
        }}
      />
    </View>
  );
};

export default SortingDropdown;

const styles = StyleSheet.create({
  sortByContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: 8,
    zIndex: 3000,
    elevation: 3000,
  },
  dropdownContainer: {
    width: 174,
    borderColor: "rgb(229, 231, 235)",
    backgroundColor: "white",
    zIndex: 3000,
    elevation: 3000,
  },
  dropdownField: {
    width: 174,
    borderColor: "rgb(229, 231, 235)",
    zIndex: 3000,
    elevation: 3000,
    minHeight: 42.5,
    backgroundColor: "white",
    borderRadius: 6,
    borderWidth: 1,
  },
  dropdownText: {
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: "700",
    color: "#344054",
  },
});
